<div>
    <div>
        <div class="d-flex justify-content-between align-items-center">
            <div class="mb-0 text-start flex-grow-0" #jumpToElementMobile>
                Showing: {{expenses().length}} of {{totalCount | number}}
            </div>
        </div>

        <!-- Table Start -->
        <div class="table-responsive d-none d-sm-block">
            <table msResponsiveTable class="table table-hover fixed-header placeholder-glow">
                <thead #jumpToElement>
                    <tr>
                        <th msResponsiveTableColumn="vendor" [priority]="1" scope="col" class="sortable"
                            (click)="toggleSortDirection('Vendor')">
                            Vendor
                            <fa-duotone-icon icon="sort" class="ms-1" size="lg"
                                [primaryOpacity]="orderBy == ExpenseListSortOptions.VendorNameAsc ? '0.9' : '0.3'"
                                [secondaryOpacity]="orderBy == ExpenseListSortOptions.VendorNameDesc ? '0.9' : '0.3'" />
                        </th>
                        <th msResponsiveTableColumn="referenceNumber" [priority]="4" scope="col" class="sortable"
                            (click)="toggleSortDirection('Reference #')">
                            Reference #
                            <fa-duotone-icon icon="sort" class="ms-1" size="lg"
                                [primaryOpacity]="orderBy == ExpenseListSortOptions.ReferenceNumberAsc ? '0.9' : '0.3'"
                                [secondaryOpacity]="orderBy == ExpenseListSortOptions.ReferenceNumberDesc ? '0.9' : '0.3'" />
                        </th>
                        <th msResponsiveTableColumn="expenseAccount" [priority]="5" scope="col" class="sortable"
                            (click)="toggleSortDirection('Expense Account')">
                            Expense Account
                            <fa-duotone-icon icon="sort" class="ms-1" size="lg"
                                [primaryOpacity]="orderBy == ExpenseListSortOptions.ExpenseAccountAsc ? '0.9' : '0.3'"
                                [secondaryOpacity]="orderBy == ExpenseListSortOptions.ExpenseAccountDesc ? '0.9' : '0.3'" />
                        </th>
                        <th msResponsiveTableColumn="amount" [priority]="1" scope="col" class="sortable numeric-column"
                            (click)="toggleSortDirection('Amount')">
                            Amount
                            <fa-duotone-icon icon="sort" class="ms-1" size="lg"
                                [primaryOpacity]="orderBy == ExpenseListSortOptions.AmountAsc ? '0.9' : '0.3'"
                                [secondaryOpacity]="orderBy == ExpenseListSortOptions.AmountDesc ? '0.9' : '0.3'" />
                        </th>
                        <th msResponsiveTableColumn="datePaid" [priority]="3" scope="col" class="sortable"
                            (click)="toggleSortDirection('Date Paid')">
                            Date Paid
                            <fa-duotone-icon icon="sort" class="ms-1" size="lg"
                                [primaryOpacity]="orderBy == ExpenseListSortOptions.DatePaidAsc ? '0.9' : '0.3'"
                                [secondaryOpacity]="orderBy == ExpenseListSortOptions.DatePaidDesc ? '0.9' : '0.3'" />
                        </th>
                        <th msResponsiveTableColumn="status" [priority]="2" scope="col" class="sortable"
                            (click)="toggleSortDirection('Status')">
                            Status
                            <fa-duotone-icon icon="sort" class="ms-1" size="lg"
                                [primaryOpacity]="orderBy == ExpenseListSortOptions.StatusAsc ? '0.9' : '0.3'"
                                [secondaryOpacity]="orderBy == ExpenseListSortOptions.StatusDesc ? '0.9' : '0.3'" />
                        </th>
                        <th msResponsiveTableColumn="actions" [priority]="1" class="fixed-header" scope="col">Actions
                        </th>
                    </tr>
                </thead>
                <tbody>
                    @for (expense of displayExpenses; let i = $index; track expense.expenseId) {
                    <tr class="align-middle" [class.even]="i % 2 === 0" [class.odd]="i % 2 !== 0">
                        <td msResponsiveTableColumn="vendor" [priority]="1">
                            <span class="vendor-cell" [class.placeholder]="isLoading"
                                [msTooltip]="expense.vendorName ?? ''" msTooltipOnlyIfTruncated>
                                {{ expense.vendorName | noValue }}
                            </span>
                        </td>
                        <td msResponsiveTableColumn="referenceNumber" [priority]="4">
                            <span [class.placeholder]="isLoading"
                                [msTooltip]="expense.referenceNumber ?? ''" msTooltipOnlyIfTruncated>{{ expense.referenceNumber | noValue }}</span>
                        </td>
                        <td msResponsiveTableColumn="expenseAccount" [priority]="5">
                            <span [class.placeholder]="isLoading"
                                [msTooltip]="expense.expenseAccount.name" msTooltipOnlyIfTruncated>{{ expense.expenseAccount.name | noValue }}</span>
                            @if (!expense.expenseAccount.isActive) {
                                <span class="badge bg-warning-subtle text-warning-emphasis ms-1">Retired</span>
                            }
                        </td>
                        <td msResponsiveTableColumn="amount" [priority]="1" class="numeric-column">
                            <span [class.placeholder]="isLoading">{{ expense.amount | CurrencyDisplay: expense.currency
                                | noValue }}</span>
                        </td>
                        <td msResponsiveTableColumn="datePaid" [priority]="3">
                            <span [class.placeholder]="isLoading">{{ expense.datePaid | orgDate: 'shortDate' | noValue
                                }}</span>
                        </td>
                        <td msResponsiveTableColumn="status" [priority]="2">
                            <ms-status-badge [status]="expense.status" [isLoading]="isLoading" />
                        </td>
                        <td msResponsiveTableColumn="actions" [priority]="1">
                            <div class="dropdown">
                                <button class="btn btn-sm btn-ms-secondary dropdown-toggle" data-bs-toggle="dropdown"
                                    [class.placeholder]="isLoading">
                                    Actions
                                </button>
                                <ul class="dropdown-menu dropdown-menu-end">
                                    <li *ifHasPermission="{requiredPermissions: [FinancialsPermission.UpdateExpense], userPermissionOnly: false, dataEntityType: DataEntityTypes.User}">
                                        <a class="dropdown-item"
                                            [class.disabled]="!canEdit(expense)"
                                            [attr.aria-disabled]="!canEdit(expense) ? 'true' : null"
                                            [attr.tabindex]="!canEdit(expense) ? -1 : null"
                                            (click)="canEdit(expense) ? editExpense(expense) : $event.stopPropagation()">
                                            <fa-duotone-icon icon="pen-to-square" secondaryOpacity="0.4" class="me-2" />Edit
                                        </a>
                                    </li>
                                    <li *ifHasPermission="{requiredPermissions: [FinancialsPermission.VoidExpense], userPermissionOnly: false, dataEntityType: DataEntityTypes.User}">
                                        <a class="dropdown-item"
                                            [class.disabled]="!canVoid(expense)"
                                            [attr.aria-disabled]="!canVoid(expense) ? 'true' : null"
                                            [attr.tabindex]="!canVoid(expense) ? -1 : null"
                                            (click)="canVoid(expense) ? confirmExpenseVoid(expense) : $event.stopPropagation()">
                                            <fa-duotone-icon icon="ban" secondaryOpacity="0.4" class="me-2" />Void
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </td>
                    </tr>
                    }
                </tbody>
                <tfoot class="overflow-auto" ms-pagination [take]="take" (loadMoreInView)="loadMoreInView()"
                    [(skip)]="skip" [hasNext]="hasNext" [itemCount]="displayExpenses.length"
                    (jumpToClicked)="jumpToTop($event)">
                </tfoot>
            </table>
        </div>
        <!-- Table End -->

        <!-- Mobile Cards Start -->
        <div id="mobileTableCards" class="d-block d-sm-none">
            @for (expense of displayExpenses; let i = $index; track expense.expenseId) {
            <div class="card d-flex pt-1 d-inline d-sm-none my-3">
                <div class="d-flex flex-column card-body">
                    <div class="d-flex flex-row align-items-start">
                        <div class="right-card-column w-100">
                            <h5 class="card-title mb-1 d-flex align-items-center gap-2 min-width-0">
                                <span class="text-truncate" [class.placeholder]="isLoading"
                                    [msTooltip]="expense.vendorName ?? ''" msTooltipOnlyIfTruncated>
                                    {{ expense.vendorName | noValue }}
                                </span>
                                <ms-status-badge [status]="expense.status" [isLoading]="isLoading" />
                            </h5>

                            @if (expense.expenseAccount.name) {
                            <div class="card-text text-muted mb-2" [class.placeholder]="isLoading">
                                {{ expense.expenseAccount.name }}
                                @if (!expense.expenseAccount.isActive) {
                                    <span class="badge bg-warning-subtle text-warning-emphasis ms-1">Retired</span>
                                }
                            </div>
                            }
                        </div>
                        <div class="text-success text-nowrap text-end ms-2 fs-5 fw-bold"
                            [class.placeholder]="isLoading">
                            {{ expense.amount | CurrencyDisplay: expense.currency | noValue }}
                        </div>
                    </div>

                    <div class="row g-2">
                        <div class="col-6 card-text" [class.placeholder]="isLoading">
                            <div class="fw-semibold">Date Paid</div>
                            {{ expense.datePaid | orgDate: 'shortDate' | noValue }}
                        </div>
                        <div class="col-6 card-text" [class.placeholder]="isLoading">
                            <div class="fw-semibold">Reference #</div>
                            {{ expense.referenceNumber | noValue }}
                        </div>
                    </div>
                </div>

                <button [attr.id]="'mobile-action-button-' + expense.expenseId"
                    class="mobile-action-button dropdown-toggle" data-bs-toggle="dropdown"
                    [class.placeholder]="isLoading">
                    Actions
                </button>
                <ul class="dropdown-menu dropdown-menu-end w-75">
                    <li *ifHasPermission="{requiredPermissions: [FinancialsPermission.UpdateExpense], userPermissionOnly: false, dataEntityType: DataEntityTypes.User}">
                        <a class="dropdown-item"
                            [class.disabled]="!canEdit(expense)"
                            [attr.aria-disabled]="!canEdit(expense) ? 'true' : null"
                            [attr.tabindex]="!canEdit(expense) ? -1 : null"
                            (click)="canEdit(expense) ? editExpense(expense) : $event.stopPropagation()">
                            <fa-duotone-icon icon="pen-to-square" secondaryOpacity="0.4" class="me-2" />Edit
                        </a>
                    </li>
                    <li *ifHasPermission="{requiredPermissions: [FinancialsPermission.VoidExpense], userPermissionOnly: false, dataEntityType: DataEntityTypes.User}">
                        <a class="dropdown-item"
                            [class.disabled]="!canVoid(expense)"
                            [attr.aria-disabled]="!canVoid(expense) ? 'true' : null"
                            [attr.tabindex]="!canVoid(expense) ? -1 : null"
                            (click)="canVoid(expense) ? confirmExpenseVoid(expense) : $event.stopPropagation()">
                            <fa-duotone-icon icon="ban" secondaryOpacity="0.4" class="me-2" />Void
                        </a>
                    </li>
                </ul>
            </div>
            }
            <div ms-in-view-port (inViewPort)="loadMoreInView()" ms-pagination [take]="take" [(skip)]="skip"
                [hasNext]="hasNext" [itemCount]="displayExpenses.length" (jumpToClicked)="jumpToTop($event)">
            </div>
        </div>
        <!-- Mobile Cards End -->
    </div>
</div>

<ms-edit-expense-modal #editExpenseModalRef (expenseUpdated)="applyExpenseUpdate($event)" />

<ms-confirmation-modal #expenseVoidConfirmationRef modalId="expenseVoidConfirmationModal"
    confirmButtonText="Void" cancelButtonText="Cancel"
    (confirmed)="confirmedExpenseVoid($event)"
    (cancelled)="cancelExpenseVoid()" />

<ms-confirmation-modal #expenseVoidBlockedRef modalId="expenseVoidBlockedModal"
    confirmButtonText="Go to Bank Reconciliation" cancelButtonText="OK"
    (confirmed)="goToBankReconciliation()"
    (cancelled)="dismissVoidBlocked()" />

<ms-info-modal #expenseListInfoRef modalId="expenseListInfoModal" (onConfirm)="infoModalConfirmed()" />
